module.exports = __webpack_public_path__ + "static/media/S2N14-3.aaf8a41a.svg";